import { render, staticRenderFns } from "./ModalProjectEdit.vue?vue&type=template&id=5658d689&"
import script from "./ModalProjectEdit.vue?vue&type=script&lang=js&"
export * from "./ModalProjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports